<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
    <breadcrumb></breadcrumb>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img class="user-avatar" src="../../../../static/images/1.png" @click="uptPassword">
        <span class="realname">{{ userName }}</span>
        <span class="out" @click="logout">【退出】</span>
      </div>
      <el-dropdown-menu class="user-dropdown">
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="修改密码"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               :show-close="true"
               :visible.sync="dialogFormVisible"
               width="40%">
      <el-form ref="psdform" :model="form">
        <el-form-item label="姓名：" :label-width="formLabelWidth">
          <div>{{userInfo.profile.name}}</div>
        </el-form-item>
        <el-form-item label="手机号：" :label-width="formLabelWidth">
          <div>{{userInfo.profile.phone}}</div>
        </el-form-item>
        <el-form-item label="账号：" :label-width="formLabelWidth">
          <div>{{userInfo.name}}</div>
        </el-form-item>
        <el-form-item label="职位：" :label-width="formLabelWidth" v-if="userInfo.company.companyType.includes('集团')">
          <div>{{userInfo.profile.duties}}</div>
        </el-form-item>
        <el-form-item label="管辖区域：" :label-width="formLabelWidth" v-if="userInfo.company.companyType.includes('集团')">
          <div v-if="userInfo.organization && userInfo.organization.length > 0"><span v-for="(item, index) in userInfo.organization" :key="index">{{ item.department }}-{{ item.area }}、</span></div>
        </el-form-item>
        <el-form-item label="新密码：" :label-width="formLabelWidth" required>
          <el-input v-model="form.newPassword" autocomplete="off" placeholder="6-16位密码，区分大小写"></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" :label-width="formLabelWidth" required>
          <el-input v-model="form.confirmPassword" autocomplete="off" placeholder="确认密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmUpt">确 定</el-button>
      </div>
    </el-dialog>
  </el-menu>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import service from '@/utils/request.js';
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'userInfo'
    ])
  },
  data(){
    return {
      userName: '',
      dialogFormVisible: false,
      formLabelWidth: '120px',
      form: {}
    }
  },
  mounted(){
    console.log('用户信息', this.userInfo);
    this.userName = this.userInfo.profile.name;
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    //登出
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
        sessionStorage.clear()
      })
    },
    //修改密码
    uptPassword(){
      this.form = {}
      this.dialogFormVisible = true;
    },
    //确认修改
    confirmUpt(){
      let self = this;
      if(this.form.newPassword != this.form.confirmPassword){
        this.$message.warning('密码不一致');
        return;
      }
      if(this.form.newPassword.length < 6 || this.form.newPassword.length > 16){
        this.$message.warning('密码长度错误，请设置8-16位密码');
        return;
      }
      let url = '/user/edit/password';
      service.postRequestJson(url, {password: this.form.newPassword, _id: this.userInfo._id}).then(res => {
        if(res.code == 0){
          this.$alert('密码修改成功，请重新登录', '提示', {
            showClose: false,
            confirmButtonText: '确定',
            callback: action => {
              self.dialogFormVisible = false;
              self.logout();
            }
          });
        }else{
          this.$message.error(res.msg);
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 5px;
      position: relative;
      display:flex;
      justify-content: center;
      .user-avatar {
        position: relative;
        top:3px;
        width:35px;
        height:35px;
        border-radius: 10px;
      }
      .realname{
        color:#999;
        margin:0 10px;
        position: relative;
        top:-3px;
      }
      .out{
        position: relative;
        top:-4px;
        left:1px;
        color:#09f;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 25px;
        font-size: 12px;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue